import { render } from "./homepage.vue?vue&type=template&id=22fb3ee8&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"

import "./homepage.vue?vue&type=style&index=0&id=22fb3ee8&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fb3ee8"]])

export default __exports__